<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="params.title"
    width="800px"
    :close-on-click-modal="false"
    class="app-main-inner edi-message-preview-dialog"
  >
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane v-for="tab in tabs" :key="tab.id" :label="tab.name" :name="tab.name" style="padding: 0 16px;">
        <el-input
          v-model="tab.content"
          no="1"
          type="textarea"
          :filter-chars="false"
          :autosize="{ minRows: 18, maxRows:24}"
        />
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" style="text-align: center;">
      <el-button v-if="!isSendRAP" no="2" type="primary" @click="toExportEDI">{{ $t('SeaExport.exportThisPageEdi') }}</el-button>
      <el-button v-if="!isSendRAP && btnShowAll" no="3" type="primary" @click="toExportAllEDI">{{ $t('SeaExport.ExportAllEDI') }}</el-button>
      <el-button v-if="!isSendRAP" no="4" type="primary" @click="toUpLoadEDI">{{ $t('SeaExport.UploadThisPageEDI') }}</el-button>
      <el-button v-if="!isSendRAP && btnShowAll" no="5" type="primary" @click="toUpLoadAllEDI">{{ $t('SeaExport.UploadAllEDI') }}</el-button>
      <el-button v-if="!isSendRAP" no="6" type="primary" @click="toUpLoadEDIByEmail">{{ $t('SeaExport.EmailUploadEDI') }}</el-button>
      <el-button v-if="isSendRAP" no="toSendRpa" type="primary" @click="toSendRpa">{{ $t('CargoMsg.Cargo_SendThisPageEDI') }}</el-button>
      <el-button v-if="isSendRAP && btnShowAll" no="toSendRpaAll" type="primary" @click="toSendRpaAll">{{ $t('CargoMsg.Cargo_SendAllEDI') }}</el-button>
      <el-button no="7" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { parseTime } from '@/utils/index.js'
import { getFtpEDI, downLoadEDI, uploadEdiFile, ydBookingEDI, getLastEdiRecord } from '@/api/seaExport/edi'
import { cacheName, cache } from '@/utils/cacheManager'
import { companyCacheByCmpIdx } from '@/api/company'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import * as EdiSendType from '@/class/cargo/model/parameters/EdiSendType'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  // EDI报文结果预览页弹窗组件
  name: 'MessagePreviewDialog',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      configMap: new Map(),
      loading: false,
      innerVisible: false,
      tabs: [],
      btnShowAll: false,
      activeName: '',
      defaultFileType: '',
      uploadEdiFileVo: {
        fileName: '',
        content: ''
      }
    }
  },
  computed: {
    // 是否发送RPA
    isSendRAP() {
      return this.params && this.params.sendRPA
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.showEDI()
      } else {
        this.tabs = []
        this.uploadEdiFileVo.fileName = ''
        this.uploadEdiFileVo.content = ''
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async mounted() {
    await cache.load(cacheName.CONFIG)
    this.configMap = cache.config
  },
  methods: {
    showEDI() {
      const ediDatas = this.params.ediCollection
      if (!ediDatas) {
        return
      }
      for (const key in ediDatas) {
        if (key === 'ediTextManifestInfoUUIDs' || key === 'sendVersion') {
          continue
        }
        if (key === 'defaultFileType') {
          this.defaultFileType = ediDatas['defaultFileType']
        } else if (key !== 'encode') {
          this.tabs.push({
            id: key,
            name: key,
            content: ediDatas[key]
          })
        }
      }
      this.activeName = this.tabs[0].name
      this.btnShowAll = this.tabs.length > 1
      this.uploadEdiFileVo.fileName = ''
      this.uploadEdiFileVo.content = ''
    },
    async toExportEDI() {
      await this.$confirm(this.$t('SeaExport.IsExportEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'info' })
      const content = this.tabs.find(tab => tab.id === this.activeName).content
      this.uploadEdiFileVo.fileName = this.$t('CargoMsg.Cargo_DataExport')
      this.uploadEdiFileVo.content = content
      // CARGO-19348 锦昶-导出报文的名称需要增加船名航次
      const job = this.params.job
      const isEDI = this.params.ediType === 1 ? 'EDI' : 'ESI'
      const jobNoByEDI = this.configMap.get('jobNoByEDI')
      let name = ''
      if (jobNoByEDI === '1') {
        name = isEDI + '_' + job.jobNo
      } else if (jobNoByEDI === '2' && (this.params.ediType === EdiType.AFR_EDI_TYPE.code || this.params.ediType === EdiType.AMS.code || this.params.ediType === EdiType.ENS.code ||
        this.params.ediType === EdiType.ACI.code || this.params.ediType === EdiType.ISF.code || this.params.ediType === EdiType.E_MANIFEST.code || this.params.ediType === EdiType.ENS_OTHER.code)) {
        name = this.params.ediTemplate.remarks + '_' + this.params.hblNbr2
      } else {
        name = new Date().getTime()
      }
      if (parseInt(this.configMap.get('CombinedManifest')) === 1 && job) {
        let fileName = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
        if (job.vessel) {
          fileName += ('_' + job.vessel)
        }
        if (job.voyageFlight) {
          fileName += ('_' + job.voyageFlight)
        }
        this.download(content, fileName, 1)
        return
      }
      this.download(content, name, 1)
    },
    async toExportAllEDI() {
      const ediDatas = this.params.ediCollection
      for (const tab of this.tabs) {
        const content = ediDatas[tab.id]
        if (content) {
          ediDatas[tab.id] = tab.content
        }
      }
      let company = await companyCacheByCmpIdx(this.params.job.carrierId)
      company = company ? company.data : null
      const fileMap = new Map()
      const nameBase = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
      let i = 0
      for (const key in ediDatas) {
        let name = nameBase
        if (company != null && company.shortName === 'PIL') {
          name += (i++ + '.pms')
        } else {
          name += (i++ + this.getExportFileFix())
        }
        fileMap.set(name, ediDatas[key])
      }
      import('@/vendor/Export2Zip').then(zip => {
        zip.export_mul_file_to_zip(fileMap, nameBase)
      })
      this.downLoadEDI(3, nameBase)
    },
    async toUpLoadEDI() {
      if (this.configMap && this.configMap.get('ToExoSystem') === 'TP') {
        // 判断最后一个记录是否是列队中
        const continueExec = await this.checkLastEdiState(this.params.job.uuid, this.params.ediType)
        if (!continueExec) {
          this.$message.warning(this.$t('SeaExport.HasBillExist', [this.params.job.jobNo]))
          return
        }
      }
      await this.$confirm(this.$t('SeaExport.UploadEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'info' })
      const content = this.tabs.find(tab => tab.id === this.activeName).content
      this.uploadEdiFileVo.fileName = this.$t('SeaExport.Send')
      this.uploadEdiFileVo.content = content
      const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
      const sendFilePrefix = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendFilePrefix
      const ediObj = {}
      ediObj['templatePath'] = !this.params.ediTemplate ? '' : this.params.ediTemplate.templatePath
      ediObj[this.activeName] = content
      if (this.params.ediCollection) {
        ediObj['ediTextManifestInfoUUIDs'] = this.params.ediCollection['ediTextManifestInfoUUIDs']
      }
      if (this.params.manifestInfo && this.params.manifestInfo.uuid && (this.params.ediType === 26)) {
        ediObj.manifestInfoKey = this.params.manifestInfo.uuid
      }
      let ediSendType = 0
      if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
        ediSendType = EdiSendType.EDI_ORIGINAL_FTP_SEND.code
      } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
        ediSendType = EdiSendType.EDI_UPDATE_FTP_SEND.code
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediObj,
        sendType: sendType,
        hblNbr2: this.params.hblNbr2 ? this.params.hblNbr2 : '',
        ensKey: this.params.ensKey ? this.params.ensKey : '',
        index: this.params.index ? this.params.index : 0,
        sendFilePrefix: sendFilePrefix,
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : '',
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        ediSendType: ediSendType
      }
      this.loading = getLoading()
      const self = this
      getFtpEDI(data).then(result => this.onFtpEDISuccess(result, data, 2)).finally(() => { self.loading.close() })
    },
    async toUpLoadAllEDI() {
      // 判断最后一个记录是否是列队中
      const continueExec = await this.checkLastEdiState(this.params.job.uuid, this.params.ediType)
      if (!continueExec) {
        this.$message.warning(this.$t('SeaExport.HasBillExist', [this.params.job.jobNo]))
        return
      }
      await this.$confirm(this.$t('SeaExport.IsUploadAllEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'info' })
      const ediTexts = this.params.ediCollection
      for (const tab of this.tabs) {
        const content = ediTexts[tab.id]
        if (content) {
          ediTexts[tab.id] = tab.content
        }
      }
      if (this.params.manifestInfo && this.params.manifestInfo.uuid && (this.params.ediType === 26)) {
        ediTexts.manifestInfoKey = this.params.manifestInfo.uuid
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediTexts,
        sendType: this.params.ediTemplate ? this.params.ediTemplate.sendType : '',
        sendFilePrefix: this.params.ediTemplate ? this.params.ediTemplate.sendFilePrefix : '',
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : ''
      }
      this.loading = getLoading()
      const self = this
      getFtpEDI(data).then(result => this.onFtpEDISuccess(result, data, 3)).finally(() => { self.loading.close() })
    },
    /**
     * 判断最后一个记录是否是列队中
     * @returns
     */
    async checkLastEdiState(jobUuid, ediType) {
      let contnueExec = true
      if ((ediType === EdiType.BOOKING_EDI_TYPE.code || ediType === EdiType.BILL_EDI_TYPE.code)) {
        const loading = getLoading()
        await getLastEdiRecord({ jobUuid: jobUuid, type: ediType }).then(res => {
          if (res.data && res.data.bookingState && (res.data.bookingState === SystemConstants.JOB_BOOKING_IN_QUEUE.code || res.data.bookingState === SystemConstants.JOB_BILL_IN_QUEUE.code)) {
            contnueExec = false
          }
        }).finally(() => loading.close())
      }
      return contnueExec
    },
    toUpLoadEDIByEmail() {
      const content = this.tabs.find(tab => tab.id === this.activeName).content
      if (!content || content.trim() === '') {
        return
      }
      const isEDI = this.params.ediType === 1 ? 'EDI' : 'ESI'
      const name = (this.configMap.get('jobNoByEDI') === '1') ? (isEDI + '_' + this.params.job.jobNo) : new Date().getTime()
      this.uploadEdiFileVo.fileName = this.$t('SeaExport.MailSending')
      this.uploadEdiFileVo.content = content
      // 导出
      this.download(content, name, 4)
      // 打开本地mail client
      let subject = name
      if (this.params.ediType === 1) {
        subject = this.params.job.jobNo
      } else if (this.params.ediType === 2) {
        subject = this.params.job.mbl
      }
      this.openLocalMailClient(subject)
    },
    cancel() {
      this.innerVisible = false
    },
    download(exportData, fileName = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}'), button = 0) {
      const exportBlob = new Blob([exportData])
      const downloadUrl = document.createElement('a')
      downloadUrl.href = window.URL.createObjectURL(exportBlob)
      downloadUrl.download = fileName + this.getExportFileFix()
      const event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0,
        0, 0, 0, false, false, false, false,
        0, null)
      downloadUrl.dispatchEvent(event)
      downloadUrl.remove()

      this.downLoadEDI(button, fileName)
      this.uploadFileToStorage(button, fileName)
    },
    // 记录发送EDI日志
    downLoadEDI(button = 0, fileName = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')) {
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: this.params.ediCollection,
        fileId: fileName,
        sendType: this.params.ediTemplate ? this.params.ediTemplate.sendType : '',
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : '',
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        status: SystemConstants.EDI_STATUS_PROCESSING // EDI状态，默认传值处理中
      }
      if (button === 1) { // 导出本页EDI
        if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
          data.ediSendType = EdiSendType.EDI_ORIGINAL_FTP_EXPORT.code
        } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
          data.ediSendType = EdiSendType.EDI_UPDATE_FTP_EXPORT.code
        }
      }
      if (button === 4) { // 邮件上传EDI
        if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
          data.ediSendType = EdiSendType.EDI_ORIGINAL_FTP_SEND.code
        } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
          data.ediSendType = EdiSendType.EDI_UPDATE_FTP_SEND.code
        }
      }
      // CARGO-25599 H5EDI模块订舱报文导出后没有打上导出标识
      if ((button === 1 || button === 3) && this.params.ediType === 1) {
        const jobKeys = this.params.hasOwnProperty('jobKeys') ? this.params.jobKeys : []
        if (jobKeys && jobKeys.length > 0) {
          const index = jobKeys.findIndex(p => p === data.jobUuid)
          if (index > -1) {
            jobKeys.splice(index, 1)
          }
        }
        data.jobKeys = jobKeys
        data.status = SystemConstants.EDI_STATUS_EXPORT_SUCCESS
      }
      if (this.params.manifestInfo && this.params.manifestInfo.uuid && (this.params.ediType === 26)) {
        data.manifestInfoKey = this.params.manifestInfo.uuid
      }
      downLoadEDI(data).then(result => {}).finally(() => {})
    },
    onFtpEDISuccess(result, data, button = 0) {
      // 订舱和提单发送若失败，进入队列再次重试
      if (this.configMap && this.configMap.get('ToExoSystem') === 'TP' && (this.params.ediType === EdiType.BOOKING_EDI_TYPE.code || this.params.ediType === EdiType.BILL_EDI_TYPE.code) && result.data && !result.data.isSuccess) {
        this.$confirm(this.$t('SeaExport.CurrentNetworkChannelUnstable'), this.$t('SeaExport.EdiTips'), {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          // 重试导入
          data.retrySize = 1
          getFtpEDI(data).then(res => { })
        }).catch((e) => {
          this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
        })
        return
      } else if (result.data && result.data.uploadResult) {
        this.uploadFileToStorage(button, result.data.uploadName)
        this.$message.info(this.$t('SeaExport.UploadEDISucceeded'))
        this.$emit('uploadSuccess', true)
        return
      }
      this.$message.error(this.$t('SeaExport.FailedToUploadEDI'))
    },
    openLocalMailClient(subject) {
      location.href = 'mailto:' + this.params.ediTemplate.email + '?subject=' + subject
    },
    /**
     * 获取Edi默认编码
     */
    getExportFileFix() {
      const ediTemplate = this.params.ediTemplate
      if (!ediTemplate || !ediTemplate.defaultFileType) {
        return this.defaultFileType ? this.defaultFileType : '.data'
      }
      return ediTemplate.defaultFileType
    },
    // 上传文件至云存储
    // button 0 默认未知, 1 导出本页EDI,2 上传本页EDI, 3 上传所有EDI, 4 邮件上传EDI
    uploadFileToStorage(button = 0, originalFile = parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')) {
      const uploadEdiFileVo = this.uploadEdiFileVo
      if (!this.uploadEdiFileVo.content) return
      const ediType = this.params.ediType
      if (ediType > 0 && [1, 2, 3, 4, 6, 7, 8, 11, 15, 30, 23, 26, 27, 43].includes(ediType)) {
        let documentType = ''
        switch (ediType) {
          case 1 : // 订舱
            documentType = 'BOOKING_EDI'
            break
          case 2 : // 提单
            documentType = 'LADING_BILL_EDI'
            break
          case 4 : // 安装箱
            documentType = 'INSTALL_EDI'
            break
          case 6 : // 预配舱单
            documentType = 'PRECONFIGURE_SHIPPING_EDI'
            break
          case 7 : // 清洁舱单
            documentType = 'IFCSUM_EDI'
            break
          case 8 : // 反恐舱单
            documentType = 'JP24SMF_EDI'
            break
          case 11 : // VGM
            documentType = 'VGM_EDI'
            break
          case 3 : // 海外代理预报
          case 15 : // 海外代理预报(包括CargoWise和荆艺接口)
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          case 30 : // 提箱
            documentType = 'SUITCASE_TYPE_EDI'
            break
          case 23 : // VGM
            documentType = 'VGM2_MANIFESTINFO_EDI'
            break
          case 26 : // 预配舱单-MANIFESTINFO方式
            documentType = 'PRECONFIGURE_MANIFESTINFO_SHIPPING_EDI'
            break
          case 27 : // 清洁舱单-MANIFESTINFO方式
            documentType = 'IFCSUM_MANIFESTINFO_EDI'
            break
          case 43 : // JCL预报
            documentType = 'OVERSEAS_AGENT_EDI'
            break
          default:
            return null
        }
        if (documentType) {
          const params = {}
          params.fileType = this.getExportFileFix()
          params.createdBy = String(this.$store.getters.userInfo.userId)
          const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
          const sendTypeItem = ChargeItemTarget.getChargeItemTargetByCode2(sendType)
          params.fileSource = (sendTypeItem && sendTypeItem.code) ? sendTypeItem.code : ''
          params.documentType = documentType
          // 文件名
          if (this.params.hasOwnProperty('ediStatusName') && this.params.ediStatusName) {
            uploadEdiFileVo.fileName = this.getButtonName(button) + this.params.ediStatusName + '_' + originalFile + this.getExportFileFix()
          } else {
            uploadEdiFileVo.fileName = uploadEdiFileVo.fileName + this.getExportFileFix()
          }
          params.uuid = encodeURIComponent(this.params.job.uuid)
          params.jobNo = this.params.job.jobNo
          uploadEdiFileVo.params = params
          uploadEdiFile(uploadEdiFileVo).then().catch()
        }
      }
    },
    getButtonName(button) {
      if (button === 1) {
        return this.$t('CargoMsg.Cargo_DataExport')
      } else if (button === 2 || button === 3) {
        return this.$t('SeaExport.Send')
      } else if (button === 4) {
        return this.$t('SeaExport.MailSending')
      }
    },
    // 发送RPA
    async toSendRpa() {
      await this.$confirm(this.$t('CargoMsg.Cargo_SendEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
      const content = this.tabs.find(tab => tab.id === this.activeName).content
      this.uploadEdiFileVo.fileName = this.$t('SeaExport.Send')
      this.uploadEdiFileVo.content = content
      const sendType = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendType
      const sendFilePrefix = !this.params.ediTemplate ? '' : this.params.ediTemplate.sendFilePrefix
      const ediObj = {}
      ediObj['templatePath'] = !this.params.ediTemplate ? '' : this.params.ediTemplate.templatePath
      ediObj[this.activeName] = content
      let ediSendType = 0
      if (this.params.ediStatusName === this.$t('SeaExport.OriginalBillOfLading')) {
        ediSendType = EdiSendType.EDI_ORIGINAL_FTP_SEND.code
      } else if (this.params.ediStatusName === this.$t('SeaExport.CorrectionOfBillOfLading')) {
        ediSendType = EdiSendType.EDI_UPDATE_FTP_SEND.code
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediObj,
        sendType: sendType,
        sendFilePrefix: sendFilePrefix,
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : '',
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        ediSendType: ediSendType
      }
      this.loading = getLoading()
      const self = this
      ydBookingEDI(data).then(result => this.onSendRpaSuccess(result, 2)).finally(() => { self.loading.close() })
    },
    async toSendRpaAll() {
      await this.$confirm(this.$t('CargoMsg.Cargo_IsSendAllEDI'), this.$t('CargoMsg.Cargo_Tips'), { type: 'warning' })
      const ediTexts = this.params.ediCollection
      for (const tab of this.tabs) {
        const content = ediTexts[tab.id]
        if (content) {
          ediTexts[tab.id] = tab.content
        }
      }
      const data = {
        jobUuid: this.params.job.uuid,
        ediType: this.params.ediType,
        ediTexts: ediTexts,
        sendType: this.params.ediTemplate ? this.params.ediTemplate.sendType : '',
        sendFilePrefix: this.params.ediTemplate ? this.params.ediTemplate.sendFilePrefix : '',
        sendVersion: this.params.sendVersion ? this.params.sendVersion : 0,
        editStatus: this.params.ediStatus ? this.params.ediStatus : 0,
        templateUuid: this.params.ediTemplate ? this.params.ediTemplate.uuid : ''
      }
      this.loading = getLoading()
      const self = this
      ydBookingEDI(data).then(result => this.onSendRpaSuccess(result, 3)).finally(() => { self.loading.close() })
    },
    onSendRpaSuccess(result, button = 0) {
      if (result.data && result.data.isSuccess) {
        this.$message.success(this.$t('CargoMsg.Cargo_SendEDISucceeded'))
        // 回调，edi.vue的回调函数执行列表数据更新
        this.$emit('uploadSuccess', true)
        this.cancel()
      } else {
        if (result.data.bookingErrorCode) {
          if (result.data.bookingErrorCode === SystemConstants.BOOKING_ERROR_USERNAME_PASSWORD_NOT_MAINTAINED.code || result.data.bookingErrorCode === SystemConstants.BOOKING_ERROR_SHIP_COMPANY_NOT_MAINTAINED.code) {
            this.$message.error(ColumnUtils.bookingErrorCodeLabelFunc(result.data))
          } else if (result.data.bookingErrorCode === SystemConstants.BOOKING_ERROR_SHIPPINGCOMPANYCODE_NOT_MAINTAINED.code) {
            this.$message.error(this.$t('CargoMsg.Cargo_ShippingCompanyCode_Maintained'))
          } else if (result.data.bookingErrorCode === SystemConstants.BOOKING_ERROR_BOOKINGCHANNEL_CONFIG_NOT_MAINTAINED.code) {
            this.$message.error(this.$t('CargoMsg.Cargo_BookingChannelConfig_Maintained'))
          }
        } else if (result.data.message) {
          this.$message.error(result.data.message)
        } else {
          this.$message.error(this.$t('CargoMsg.Cargo_FailedToSendEDI'))
        }
      }
    }
  }
}
</script>

<style lang="scss">
.edi-message-preview-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-tabs__header {
    margin-bottom: 5px !important;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>
